var $e73bf42412feb220$exports = {};
const { algoliasearch: $e73bf42412feb220$var$algoliasearch, instantsearch: $e73bf42412feb220$var$instantsearch } = window;
const $e73bf42412feb220$var$searchClient = $e73bf42412feb220$var$algoliasearch('F67GQP37J2', 'ZDBlYjRiOGMyMDRlM2JjZmIwYzdhMWRlNWI5NWEzNDdkMDEwZWYxYTQ4OGU0MjY4ZTM3Y2JhZTE5NWQwYzZlMXJlc3RyaWN0SW5kaWNlcz1jZG5fZmxpcnB1YmxpY192MSombnVtZXJpY0ZpbHRlcnM9JTVCJTVCJTIydmlzaWJpbGl0eSUzRTIwMCUyMiU1RCU1RA==');
const $e73bf42412feb220$var$indexName = 'cdn_flirpublic_v1';
const $e73bf42412feb220$var$widgetsForAttributes = {
    'meta.productname': 'menu',
    'meta.pubtype': 'menu',
    'format': 'refinementList',
    'lang': 'menu'
};
let $e73bf42412feb220$var$url = window.location.href.split('?')[0];
let $e73bf42412feb220$var$params = new URLSearchParams(window.location.search);
if (!$e73bf42412feb220$var$params.has('lang')) $e73bf42412feb220$var$params.set('lang', 'en-US');
window.history.replaceState(history.state, "", $e73bf42412feb220$var$url + "?" + $e73bf42412feb220$var$params.toString());
const $e73bf42412feb220$var$search = $e73bf42412feb220$var$instantsearch({
    searchClient: $e73bf42412feb220$var$searchClient,
    indexName: $e73bf42412feb220$var$indexName,
    routing: {
        stateMapping: {
            stateToRoute (uiState) {
                const state = uiState[$e73bf42412feb220$var$indexName];
                const route = {
                    query: state.query,
                    page: state.page
                };
                [
                    'refinementList',
                    'hierarchicalMenu',
                    'menuSelect',
                    'menu'
                ].forEach((widget)=>{
                    if (state[widget]) for(var attribute in state[widget])route[attribute] = state[widget][attribute];
                });
                return route;
            },
            routeToState (routeState) {
                const state = {
                    [$e73bf42412feb220$var$indexName]: {
                        refinementList: {},
                        hierarchicalMenu: {},
                        menuSelect: {},
                        menu: {}
                    }
                };
                for(const key in routeState){
                    if (key in $e73bf42412feb220$var$widgetsForAttributes) {
                        const widget = $e73bf42412feb220$var$widgetsForAttributes[key];
                        state[$e73bf42412feb220$var$indexName][widget][key] = routeState[key];
                        continue;
                    }
                    [
                        'query',
                        'page'
                    ].forEach((attribute)=>{
                        if (key === attribute) state[$e73bf42412feb220$var$indexName][attribute] = routeState[key];
                    });
                }
                return state;
            }
        }
    }
});
function $e73bf42412feb220$var$get(fallback, obj, level, ...rest) {
    if (obj === undefined || obj === null) return fallback;
    if (rest.length === 0 && obj.hasOwnProperty(level)) {
        if (obj[level] === null && fallback !== null) return fallback;
        return obj[level];
    }
    return $e73bf42412feb220$var$get(fallback, obj[level], ...rest);
}
function $e73bf42412feb220$var$set(obj, level, ...rest) {
    if (obj === undefined || obj === null) throw Error("Invalid object supplied!");
    if (level === undefined || level === null) throw Error("At least one level must be supplied");
    if (rest.length === 0) throw Error("A value must be supplied as the last argument!");
    if (rest.length === 1) obj[level] = rest[0];
    else $e73bf42412feb220$var$set(obj[level], ...rest);
}
function $e73bf42412feb220$var$transformItems(attributes, items) {
    if (attributes) {
        if (!Array.isArray(attributes)) attributes = [
            attributes
        ];
        // a specific attribute (facet)
        return items.map((item)=>{
            for (const attribute of attributes){
                if (attribute in transformations && item.label in transformations[attribute]) return {
                    ...item,
                    label: transformations[attribute][item.label],
                    highlighted: transformations[attribute][item.label]
                };
            }
            return item;
        });
    } else // search results
    return items.map((item)=>{
        let result = Object.assign({}, item);
        for(let attribute in item)if (attribute in transformations && item[attribute] in transformations[attribute]) result = {
            ...result,
            [attribute]: transformations[attribute][item[attribute]]
        };
        else Object.keys(transformations).forEach((attribute)=>{
            let fields = attribute.split('.');
            if (fields.length > 0) {
                let value = $e73bf42412feb220$var$get(null, item, ...fields);
                if (value != null && value in transformations[attribute]) $e73bf42412feb220$var$set(result, ...fields, transformations[attribute][value]);
            }
        });
        return result;
    });
}
$e73bf42412feb220$var$search.addWidgets([
    $e73bf42412feb220$var$instantsearch.widgets.searchBox({
        container: '#searchbox',
        keepDiacriticsOnCharacters: [
            "\xe5",
            "\xe4",
            "\xf6"
        ],
        placeholder: 'Search by Product Category, Product Family, or Product Model',
        queryHook (query, searchFn) {
            if (query.length > 0) // Temporarily clear refinements for global search
            $e73bf42412feb220$var$search.helper.clearRefinements();
            searchFn(query);
        }
    }),
    //instantsearch.widgets.configure({
    //  distinct: 1
    //}),
    $e73bf42412feb220$var$instantsearch.widgets.hits({
        container: '#hits',
        transformItems (items) {
            const transformed = $e73bf42412feb220$var$transformItems(null, items);
            return items.map((item)=>({
                    ...item,
                    showLanguagePicker: item.format !== 'pdf'
                }));
        },
        templates: {
            item: `
<article class="card h-100">
  <div class="card-body">
    <a class="link-primary text-decoration-none" href="https://docs.flir.com{{ url }}">
    <h4 class="card-title">{{ meta.pubtitle }}</h4></a>
    <a class="link-primary text-decoration-none" href="https://docs.flir.com{{ url }}">
    <h6 class="card-subtitle mb-2">{{ meta.pubtype-displayname }}</h6>
    </a>
  </div>
  <div class="card-footer mt-auto">
    <div class="row justify-content-end">
         
      {{#showLanguagePicker}}
      <div class="col-auto">
        <language-picker
          size="sm"
          lazy="true"
          class="navbar-language-picker"
          variant="lp"
          menuVariant="lp"
          buttonIconSrc="data:image/svg+xml;base64,PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KDTwhLS0gVXBsb2FkZWQgdG86IFNWRyBSZXBvLCB3d3cuc3ZncmVwby5jb20sIFRyYW5zZm9ybWVkIGJ5OiBTVkcgUmVwbyBNaXhlciBUb29scyAtLT4KDTxzdmcgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDE1IDE1IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHN0cm9rZT0iI2ZmZmZmZiI+Cg08ZyBpZD0iU1ZHUmVwb19iZ0NhcnJpZXIiIHN0cm9rZS13aWR0aD0iMCIvPgoNPGcgaWQ9IlNWR1JlcG9fdHJhY2VyQ2FycmllciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cg08ZyBpZD0iU1ZHUmVwb19pY29uQ2FycmllciI+IDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNC4xODE3OSA2LjE4MTgxQzQuMzU3NTMgNi4wMDYwOCA0LjY0MjQ1IDYuMDA2MDggNC44MTgxOSA2LjE4MTgxTDcuNDk5OTkgOC44NjM2MkwxMC4xODE4IDYuMTgxODFDMTAuMzU3NSA2LjAwNjA4IDEwLjY0MjQgNi4wMDYwOCAxMC44MTgyIDYuMTgxODFDMTAuOTkzOSA2LjM1NzU1IDEwLjk5MzkgNi42NDI0NyAxMC44MTgyIDYuODE4MjFMNy44MTgxOSA5LjgxODIxQzcuNzMzNzkgOS45MDI2IDcuNjE5MzQgOS45NTAwMSA3LjQ5OTk5IDkuOTUwMDFDNy4zODA2NCA5Ljk1MDAxIDcuMjY2MTggOS45MDI2IDcuMTgxNzkgOS44MTgyMUw0LjE4MTc5IDYuODE4MjFDNC4wMDYwNSA2LjY0MjQ3IDQuMDA2MDUgNi4zNTc1NSA0LjE4MTc5IDYuMTgxODFaIiBmaWxsPSIjZmZmZmZmIi8+IDwvZz4KDTwvc3ZnPg=="
          docno="{{docno}}"
          default="{{lang}}"
          version="{{version}}"
          urlprefix="https://docs.flir.com"
          algoliaAppId="F67GQP37J2"
          algoliaApiKey="ZDBlYjRiOGMyMDRlM2JjZmIwYzdhMWRlNWI5NWEzNDdkMDEwZWYxYTQ4OGU0MjY4ZTM3Y2JhZTE5NWQwYzZlMXJlc3RyaWN0SW5kaWNlcz1jZG5fZmxpcnB1YmxpY192MSombnVtZXJpY0ZpbHRlcnM9JTVCJTVCJTIydmlzaWJpbGl0eSUzRTIwMCUyMiU1RCU1RA=="
          algoliaIndexName="cdn_flirpublic_v1"
        ></language-picker>
      </div>
      {{/showLanguagePicker}}
    </div>
  </div>
</article>
`
        }
    }),
    $e73bf42412feb220$var$instantsearch.widgets.menu({
        container: '#productname-menu',
        transformItems: $e73bf42412feb220$var$transformItems.bind($e73bf42412feb220$exports, 'meta.productname'),
        attribute: 'meta.productname',
        cssClasses: {
            link: 'link-primary'
        }
    }),
    $e73bf42412feb220$var$instantsearch.widgets.menu({
        container: '#pubtype-menu',
        transformItems: $e73bf42412feb220$var$transformItems.bind($e73bf42412feb220$exports, 'meta.pubtype'),
        attribute: 'meta.pubtype',
        cssClasses: {
            link: 'link-primary'
        }
    }),
    $e73bf42412feb220$var$instantsearch.widgets.refinementList({
        container: '#format-list',
        transformItems: $e73bf42412feb220$var$transformItems.bind($e73bf42412feb220$exports, 'format'),
        attribute: 'format'
    }),
    $e73bf42412feb220$var$instantsearch.widgets.menuSelect({
        container: '#lang-select',
        transformItems: $e73bf42412feb220$var$transformItems.bind($e73bf42412feb220$exports, 'lang'),
        attribute: 'lang',
        templates: {
            defaultOption: 'Any'
        }
    }),
    $e73bf42412feb220$var$instantsearch.widgets.hierarchicalMenu({
        container: '#taxonomy-menu',
        separator: ' / ',
        transformItems: $e73bf42412feb220$var$transformItems.bind($e73bf42412feb220$exports, 'meta.taxonomy-lvl0'),
        attributes: [
            'meta.taxonomy-lvl0',
            'meta.taxonomy-lvl1'
        ]
    }),
    $e73bf42412feb220$var$instantsearch.widgets.pagination({
        container: '#pagination'
    }),
    $e73bf42412feb220$var$instantsearch.widgets.configure({
        filters: 'lang:"en-US" AND NOT meta.pubtype:"UM" OR NOT format:"pdf"',
        restrictSearchableAttributes: [
            'meta.taxonomy-lvl1',
            'meta.taxonomy-lvl0',
            'meta.productname'
        ]
    })
]);
$e73bf42412feb220$var$search.start();


//# sourceMappingURL=se.simonsoft.dita.flir.public.2fc2beff.js.map
